import axios from "axios";

export function requestPutPrivilege(params: any) {
    return axios.request({
        withCredentials: true,
        method: 'put',
        url: "/api/privilege",
        headers: {
            'content-type': 'application/json'
        },
        data: params,
    });

}